import { isBrowser } from './env'

const DEBUG_KEY = 'analytics_debug'

// The flag is read on every enriched event, so the resolution is memoized per
// location.search — a SPA navigation (new search string) re-evaluates it, a
// burst of events does not re-parse the URL or re-hit sessionStorage.
let cachedSearch: string | undefined
let cachedEnabled = false

const resolveDebugEnabled = (search: string): boolean => {
  try {
    const param = new URLSearchParams(search).get(DEBUG_KEY)
    if (param === '1') {
      window.sessionStorage.setItem(DEBUG_KEY, '1')
      return true
    }
    if (param === '0') {
      window.sessionStorage.removeItem(DEBUG_KEY)
      return false
    }
    return window.sessionStorage.getItem(DEBUG_KEY) === '1'
  } catch {
    return false
  }
}

/**
 * FC-183 §8 debug mode. `?analytics_debug=1` turns it on for the rest of the
 * tab's session (SPA navigations drop the query string, so the flag persists
 * in sessionStorage); `?analytics_debug=0` turns it off again.
 * Fails closed: any storage error means "not enabled".
 */
export const isAnalyticsDebugEnabled = (): boolean => {
  if (!isBrowser()) {
    return false
  }

  const search = window.location.search
  if (cachedSearch !== search) {
    cachedSearch = search
    cachedEnabled = resolveDebugEnabled(search)
  }
  return cachedEnabled
}

/**
 * Renders one fully enriched event payload as it fires, so "what actually got
 * sent" is a console check instead of a network-tab excavation.
 */
export const debugLogEvent = (
  type: string,
  name: string | undefined,
  payload: unknown,
): void => {
  console.info(`[${DEBUG_KEY}] ${type}${name ? ` "${name}"` : ''}`, payload)
}
